import { API_BASE_URL } from './config';
import { apiFetch } from './apiFetch';

export type OrgLevelDto = {
  id: string;
  companyId: string;
  level: number;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
};

export async function listOrgLevels(companyId: string) {
  const res = await apiFetch(
    `${API_BASE_URL}/api/org-levels/company/${companyId}`,
    { headers: { 'Content-Type': 'application/json' } },
  );
  return res.json() as Promise<{ success: boolean; data?: { orgLevels: OrgLevelDto[] }; error?: string }>;
}

export async function createOrgLevel(
  input: { companyId: string; level: number; name: string; description?: string },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/org-levels`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { orgLevel: OrgLevelDto }; error?: string }>;
}

export async function updateOrgLevel(
  id: string,
  input: { companyId: string; level?: number; name?: string; description?: string },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/org-levels/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { orgLevel: OrgLevelDto }; error?: string }>;
}

export async function deleteOrgLevel(id: string, companyId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/org-levels/${id}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ companyId }),
  });
  return res.json() as Promise<{ success: boolean; error?: string }>;
}
